<button
  class="btn-bare panel-card-button"
  nf-icon-button="secondary"
  [icon]="isPanelAdded ? 'minus' : 'plus'"
  [ngbTooltip]="label"
  placement="top-left"
  (click)="togglePanel($event)"
  [attr.aria-label]="label"
  [disabled]="panelMetadata?.hasAccess !== true"
>
  {{ isPanelAdded ? 'Close Panel' : 'Add Panel' }}
</button>
<div
  class="card-detail"
  [ngbTooltip]="
    panelMetadata?.hasAccess !== true
      ? 'To request access to this panel, please contact your Sales or Client Services representative'
      : ''
  "
  container="body"
>
  <h5 class="mb-0">
    {{ panelMetadata?.title }}
  </h5>
  <p class="small mb-0">
    {{ panelMetadata?.description }}
  </p>
</div>
<div
  class="drag-zone"
  #dragZone
  [ngClass]="{ disabled: isPanelAdded || panelMetadata?.hasAccess !== true }"
></div>
